import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import EmployeeSelfServiceAssignmentSection from '../../services/service-staff-assignment/EmployeeSelfServiceAssignmentSection';
import { isSelfServiceAssignmentEnabled } from '../../services/service-staff-assignment/employeeSelfServiceAssignmentUtils';
import './MyServicesSettingsPage.css';

const MyServicesSettingsPage = () => {
  const { user, companyData } = useAuth();
  const selfServiceEnabled = isSelfServiceAssignmentEnabled(companyData);
  const isOwner = String(user?.role || '').toLowerCase() === 'owner';

  if (isOwner) {
    return (
      <Navigate
        to="/app/overview/settings"
        replace
        state={{ section: 'services-categories', parent: 'services-categories' }}
      />
    );
  }

  const employee = {
    id: user?.uid,
    firstName: user?.firstName,
    lastName: user?.lastName,
    locationIds: user?.locationIds || [],
    role: user?.role,
  };

  if (!selfServiceEnabled) {
    return (
      <div className="my-services-settings-page">
        <div className="my-services-settings-page__header">
          <h1 className="my-services-settings-page__title">My Services</h1>
          <p className="my-services-settings-page__description">
            Your business has not enabled employee self-assignment yet. Ask the owner to turn this on
            in Manage Services.
          </p>
        </div>
        <EmployeeSelfServiceAssignmentSection employee={employee} canSelfManage={false} />
      </div>
    );
  }

  return (
    <div className="my-services-settings-page">
      <div className="my-services-settings-page__header">
        <h1 className="my-services-settings-page__title">My Services</h1>
        <p className="my-services-settings-page__description">
          Choose which services you are available to perform. Only services at your assigned
          locations are listed.
        </p>
      </div>
      <EmployeeSelfServiceAssignmentSection employee={employee} canSelfManage />
    </div>
  );
};

export default MyServicesSettingsPage;
